import { render, staticRenderFns } from "./LazyLoader.vue?vue&type=template&id=85e691ea&scoped=true&"
import script from "./LazyLoader.vue?vue&type=script&lang=js&"
export * from "./LazyLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e691ea",
  null
  
)

export default component.exports